// Reconcile a reported push failure against the server's billingPush slot.
// CommonJS so Jest can require it directly (same pattern as assessment-risk.js);
// imported by push-emr.js / the studio + push-modal handlers.
//
// When a Push & Sign reports failure (ok:false or a thrown error), the bill may
// in fact be filed in Elation — two transient origins cause this:
//   A) the bill posted but the client's post-push billed-state save failed
//      (the server route finalizes its slot independently, so the slot is
//       already 'pushed');
//   B) the network response was lost after Elation created the note (the server
//      finalizes 'pushed', or parks 'bill_failed' on the orphan path).
// The server billingPush slot is the source of truth; reading it lets the UI
// show an accurate message instead of a misleading red "failed".

// The push-careplan route claims data.billingPush[`${month}|${ccm|bhi}`]; this
// MUST match server/routes/elationSync.js pushSlotKey.
function billingPushSlotKey(monthStr, program) {
  return String(monthStr) + '|' + (program === 'bhi' ? 'bhi' : 'ccm');
}

// Classify a billingPush slot entry into what it means for a reported failure:
//   'pushed'      — finalized: the bill is in Elation (the "failure" was false).
//   'bill_failed' — an orphaned visit note is in Elation; needs manual cleanup.
//   null          — no evidence the bill landed (incl. 'pending', which is
//                   ambiguous: in-flight, or died mid-push) → genuine failure.
// Deliberately conservative: only the two terminal server states downgrade a
// reported failure; 'pending' never claims success.
function reconciledPushState(slotEntry) {
  if (!slotEntry || typeof slotEntry !== 'object') return null;
  if (slotEntry.status === 'pushed') return 'pushed';
  if (slotEntry.status === 'bill_failed') return 'bill_failed';
  return null;
}

module.exports = { billingPushSlotKey, reconciledPushState };
